import { MenuEntryModel } from './menu-entry.model';

export class MenuSectionModel {
    public constructor(
        public title: string,
        public entries: MenuEntryModel[] = [],
    ) {}
}
